import type { TypePolicies } from '../../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  Account: {
    fields: {
      permissions: {
        merge: true,
      },
    },
  },
  FolderAsset: {
    fields: {
      permissions: {
        merge: false,
      },
    },
  },
  Project: {
    fields: {
      permissions: {
        merge: true,
      },
    },
  },
  Workspace: {
    fields: {
      permissions: {
        merge: true,
      },
    },
  },
};
